<template>
  <div id="mainFrame">
    <v-row>
      <h1>Motiverse Hilfezentrum</h1>
    </v-row>
    <v-row>
      <v-tabs v-model="currentTab" color="secondary">
        <v-tab
          id="tab"
          v-for="tab in tabs"
          :key="tab.key"
          :href="'#' + tab.key"
        >
          {{ tab.name }}
          <v-spacer />
        </v-tab>
      </v-tabs>
    </v-row>
    <v-row>
      <div v-model="currentTab" class="full-width">
        <div v-if="currentTab == 'bugreport'">
          <v-row class="mt-10 px-10">
            <v-col cols="5">
              <v-card
                flat
                class="border-right d-flex flex-column align-center py-10 px-10"
              >
                <div class="pt-10 mt-10 mb-5">
                  <svg
                    width="154"
                    height="138"
                    viewBox="0 0 154 138"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <ellipse
                      cx="89.2472"
                      cy="71.8363"
                      rx="62.5"
                      ry="67.5"
                      transform="rotate(40.5307 89.2472 71.8363)"
                      fill="#F1F1F1"
                    />
                    <g clip-path="url(#clip0_0_6487)">
                      <path
                        d="M144.479 62.9183C144.479 42.9257 123.533 26.6831 97.2931 25.8475C99.0978 29.6993 100.112 33.8364 100.112 38.1569C100.112 58.6793 78.0495 75.3091 50.8164 75.3091C50.1067 75.3091 49.4172 75.248 48.7075 75.2276C55.3992 89.5953 73.4464 99.9278 94.7786 100.07C98.5706 108.834 107.249 114.948 117.368 114.948C119.943 114.948 122.438 114.54 124.769 113.806C117.429 111.483 111.589 105.818 108.993 98.5828C129.494 94.0788 144.5 79.8334 144.5 62.9183H144.479Z"
                        stroke="#B7B7B7"
                        stroke-width="3"
                        stroke-miterlimit="10"
                      />
                      <path
                        d="M97.2929 25.8271C90.5404 11.3779 72.3107 0.984253 50.8163 0.984253C23.5832 0.984253 1.521 17.6141 1.521 38.1365C1.521 51.8724 11.4571 63.8557 26.1585 70.2753V70.3365C26.1585 81.423 18.8991 90.8181 8.90211 93.9769C11.2341 94.7106 13.7282 95.1182 16.3035 95.1182C28.5107 95.1182 38.6091 86.1919 40.576 74.4939C43.2121 74.9219 45.9293 75.1257 48.7074 75.2276C49.4171 75.248 50.1065 75.3091 50.8163 75.3091C78.0493 75.3091 100.112 58.6793 100.112 38.1569C100.112 33.8364 99.0774 29.6993 97.2929 25.8475V25.8271Z"
                        stroke="#B7B7B7"
                        stroke-width="3"
                        stroke-miterlimit="10"
                      />
                      <path
                        d="M28.6323 38.1365H33.5598"
                        stroke="#B7B7B7"
                        stroke-width="3"
                        stroke-miterlimit="10"
                      />
                      <path
                        d="M38.4873 38.1365H43.4148"
                        stroke="#B7B7B7"
                        stroke-width="3"
                        stroke-miterlimit="10"
                      />
                      <path
                        d="M48.3423 38.1365H53.2901"
                        stroke="#B7B7B7"
                        stroke-width="3"
                        stroke-miterlimit="10"
                      />
                      <path
                        d="M58.2178 38.1365H63.1453"
                        stroke="#B7B7B7"
                        stroke-width="3"
                        stroke-miterlimit="10"
                      />
                      <path
                        d="M68.0728 38.1365H73.0003"
                        stroke="#B7B7B7"
                        stroke-width="3"
                        stroke-miterlimit="10"
                      />
                      <path
                        d="M97.6577 62.9183H102.585"
                        stroke="#B7B7B7"
                        stroke-width="3"
                        stroke-miterlimit="10"
                      />
                      <path
                        d="M107.513 62.9183H112.44"
                        stroke="#B7B7B7"
                        stroke-width="3"
                        stroke-miterlimit="10"
                      />
                      <path
                        d="M117.368 62.9183H122.295"
                        stroke="#B7B7B7"
                        stroke-width="3"
                        stroke-miterlimit="10"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_0_6487">
                        <rect width="146" height="117" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                </div>
                <h3>Senden Sie uns Feedback!</h3>
                <p class="mt-4">
                  Beschreiben Sie ein Problem oder einen Vorschlag. Damit wir
                  das Problem oder den Vorschlag besser verstehen können, hängen
                  Sie bitte einen Screenshot an.
                </p>
                <p class="mt-4">
                  Nachdem Ihr Anliegen übermittelt wurde, wird automatisch ein
                  Ticket erstellt. Wir kümmern uns schnellstmöglich darum.
                </p>
              </v-card>
            </v-col>
            <v-col cols="7">
              <iframe
                id="zsfeedbackFrame"
                width="890"
                height="570"
                name="zsfeedbackFrame"
                scrolling="no"
                allowtransparency="false"
                frameborder="0"
                border="0"
                src="https://desk.zoho.eu/support/fbw?formType=AdvancedWebForm&fbwId=edbsne23b1c60b2853d4b2ef85ad086d0e42fbaf2a369b620a780db6f7177daf45db5&xnQsjsdp=edbsn0106b319e848a04654354fb9bd28ae80&mode=showNewWidget&displayType=iframe"
              ></iframe>
            </v-col>
          </v-row>
        </div>
        <div v-if="currentTab == 'userhandbook'">
          <v-row class="mt-10 px-10">
            <v-col
              cols="6"
              class="d-flex flex-column align-center border-right px-10"
            >
              <div style="transform: scale(80%)">
                <svg
                  width="134"
                  height="151"
                  viewBox="0 0 134 151"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <ellipse
                    cx="62.744"
                    cy="100.557"
                    rx="62.5"
                    ry="49.381"
                    transform="rotate(-3.93825 62.744 100.557)"
                    fill="#F1F1F1"
                  />
                  <g clip-path="url(#clip0_0_6487)">
                    <path
                      d="M56.8699 112.616H29.8896C24.0464 112.616 19.2703 107.824 19.2703 101.961V11.9294C19.2703 6.01571 24.0464 1.27454 29.8896 1.27454H96.9085L96.8068 99.0039"
                      stroke="#B7B7B7"
                      stroke-width="3"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M48.5878 108.231H30.3469C24.2496 108.231 24.2496 99.0549 30.3469 99.0549C75.5172 99.0549 96.9084 99.0549 96.9084 99.0549"
                      stroke="#B7B7B7"
                      stroke-width="3"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M100.16 6.42354L106.004 4.99609L120.637 65.8157"
                      stroke="#B7B7B7"
                      stroke-width="3"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M120.484 65.8667L127.801 96.5059L63.1704 112.004L61.1379 103.592"
                      stroke="#B7B7B7"
                      stroke-width="3"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M115.251 33.5961L132.73 42.5686L122.72 61.6863"
                      stroke="#B7B7B7"
                      stroke-width="3"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M35.8345 101.553L87.6102 128.726L99.6014 105.835"
                      stroke="#B7B7B7"
                      stroke-width="3"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M58.8516 6.57643V36.5019L49.4009 25.3882L40.001 36.5019V1.47839"
                      stroke="#B7B7B7"
                      stroke-width="3"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_0_6487">
                      <rect
                        width="116"
                        height="130"
                        fill="white"
                        transform="translate(18)"
                      />
                    </clipPath>
                  </defs>
                </svg>
              </div>

              <h3>Benutzerhandbuch</h3>
              <p class="mt-4">
                Hier erhalten Sie Informationen zu den Anwendungsmöglichkeiten
                der Plattform. Das Benutzerhandbuch gibt Ihnen einen Überblick
                über die Funktionen. Klicken Sie dafür auf "Benutzerhandbuch"
                und öffnen Sie dieses.
              </p>
              <p>
                Haben Sie weitere Fragen oder Ihr Problem wurde nicht gelöst?
                Melden Sie sich gerne bei uns indem Sie
                <a href="#bugreport" @click="currentTab = 'bugreport'">hier</a>
                klicken.
              </p>
              <v-btn
                rounded
                large
                color="secondary"
                elevation="0"
                style="
                  -webkit-border-radius: 24px;
                  -moz-border-radius: 24px;
                  border-radius: 24px;
                "
                class="mt-6"
                href="https://motiverse-userhandbook.netlify.app/"
                target="_blank"
              >
                Benutzerhandbuch öffnen
                <v-icon small class="ml-2">mdi-open-in-new</v-icon>
              </v-btn>
            </v-col>
            <v-col cols="5">
              <h3 class="text-center">Inhalt</h3>
              <v-list>
                <v-list-group
                  v-for="content in handbook"
                  :key="content.title"
                  no-action
                >
                  <template v-slot:activator>
                    <v-list-item-content color="primary">
                      <v-list-item-title
                        v-text="content.title"
                        color="primary"
                      ></v-list-item-title>
                    </v-list-item-content>
                  </template>

                  <v-list-item
                    v-for="child in content.items"
                    :key="child.title"
                    color="primary"
                    style="min-height: 32px"
                  >
                    <v-list-item-content class="pa-0">
                      <v-list-item-title
                        v-text="child.title"
                        class="font-m text-gray"
                      ></v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list-group>
              </v-list>
            </v-col>
          </v-row>
        </div>
        <div v-if="currentTab == 'changelog'">
          <v-row class="mt-10 px-10 d-flex justify-center">
            <v-col cols="7">
              <h2><v-icon class="mr-2">mdi-source-branch</v-icon>Changelog</h2>
              <div
                v-for="changelog in changelogs"
                :key="changelog"
                class="px-6 py-4 mt-10 card"
              >
                <v-chip
                  small
                  label
                  class="version-info"
                  color="lightblue_s"
                  text-color="lightblue"
                >
                  {{ changelog.versionInfo }}
                </v-chip>
                <div
                  class="d-flex flex-row justify-space-between align-baseline"
                >
                  <h3>Fehlerbehebungen</h3>
                  <div class="float-right text-description">
                    {{ changelog.date }}
                  </div>
                </div>
                <ul style="list-style: circle">
                  <li v-for="fix in changelog.fixes" :key="fix">
                    <p>{{ fix }}</p>
                  </li>
                </ul>
              </div>
            </v-col>
          </v-row>
        </div>
        <div v-if="currentTab == 'lessons'">
          <LearnPage />
        </div>
        <v-col> </v-col>
      </div>
    </v-row>
  </div>
</template>

<script>
import LearnPage from "./LearnPage.vue";

export default {
  data: () => ({
    tabs: [
      { name: "Bug Report", key: "bugreport", description: "" },
      { name: "BPMN Schulung", key: "lessons", description: "" },
      /*      {name: 'Benutzerhandbuch', key: 'userhandbook', description: ''},*/
      { name: "Changelog", key: "changelog", description: "" },
    ],
    currentTab: "bugreport",
    handbook: [
      {
        title: "Anmeldung auf der Plattform",
        items: [
          { title: "Setzen des Passworts" },
          { title: "Zurücksetzen des Passworts" },
        ],
      },
      {
        title: "Startseite",
        items: [{ title: "Dashboard" }],
      },
      {
        title: "Prozesse",
        items: [
          { title: "Übersicht über alle Prozesse" },
          { title: "Meine Prozesse" },
          { title: "Freigegebene Prozesse" },
          { title: "Anlegen eines neuen Prozessmodells" },
          { title: "BPMN 2.0 Prozesselemente" },
          { title: "Umfrage eines Prozessmodells öffnen" },
        ],
      },
      {
        title: "Fragen",
        items: [
          { title: "Übersicht über alle Fragen" },
          { title: "Meine Fragen" },
          { title: "Mandantenfragen" },
          { title: "Fragen suchen" },
          { title: "Neue Frage hinzufügen" },
        ],
      },
      {
        title: "Umfragen",
        items: [
          { title: "Erstellen einer neuen Umfrage" },
          { title: "Startseite einer Umfrage" },
          { title: "Umfrage versenden" },
        ],
      },
      {
        title: "Auswertung der Umfragen",
        items: [
          { title: "Arbeitswissenschaftliche Umfragen" },
          { title: "Manuelle Umfragen" },
          { title: "Prozessorientiertes Modul" },
        ],
      },
      {
        title: "Checkliste der Innovationsprozesse",
        items: [
          { title: "Übersicht über alle Checklisten" },
          { title: "Meine Checklisten" },
          { title: "Entwürfe" },
          { title: "Neue Checkliste erstellen" },
        ],
      },
      {
        title: "Nutzerverwaltung",
        items: [
          { title: "Nutzerverwaltung" },
          { title: "Rollenverwaltung und Rechteverteilung" },
          /* {title: 'Externe WFMS-Schnittstelle'}, */
          { title: "Mandantenverwaltung" },
        ],
      },
      {
        title: "Hilfebereich",
        items: [{ title: "Hilfebereich" }],
      },
    ],
    changelogs: [
      {
        versionInfo: "v4.2.7",
        date: "02.06.2025",
        fixes: [
          " MO1-T289: Die Elementnummerierung funktioniert nun zuverlässig.",
          " MO1-T295: Der Bericht wird nun nach DIN erstellt (inkl. letztem Bearbeitenden, Seitenzahl, etc.)",
          " MO1-T296: Gelöschte Elemente werden nun berücksichtigt, sodass es nicht mehr zu einer Fehlermeldung kommt, wenn eine Aktivität mit der Zahl des gelöschten Elements nummeriert wird.",
        ],
      },
      {
        versionInfo: "v4.2.6",
        date: "02.04.2025",
        fixes: [
          " MO1-T290: Berichte können nun auch dann heruntergeladen werden, wenn der Nutzende nicht der Prozesseigentümer ist",
          " MO1-T288: Im Bericht ist nun sichtbar, wer das Prozessmodell zuletzt bearbeitet hat",
        ],
      },

      {
        versionInfo: "v4.2.5",
        date: "17.02.2025",
        fixes: [
          " MO1-T277: Beim Export eines Berichtes werden nun alle Spalten ausgefüllt",
          " MO1-T283: Das Anlegen und Hinzufügen von Rollen funktioniert wieder",
          " MO1-T281: Der Button „Bericht exportieren“ funktioniert nun zuverlässig",
          " MO1-T280: Beim Hinzufügen eines Prozesssteckbriefes schließt sich das Dialogfenster nicht mehr",
          " MO1-T279: Das Abspeichern des Prozesssteckbriefes funktioniert nun zuverlässig. Zuvor hatte dies aufgrund der falschen Nummerierung der Schritte nicht mehr funktioniert",
          " MO1-T268: Der Hinzufügen-Button, um einen Prozesssteckbrief zu einem bestehenden Prozess hinzuzufügen, funktioniert wieder",
          " MO1-T276: Nummerierungen werden nun auch auf Aktivitäten mit Ausprägungen angewandt",
          " MO1-T230: Beim Ändern der Nutzer-ID (E-Mail-Adresse) eines Nutzers durch den Admin verschwindet dieser nun nicht mehr aus der Nutzerliste",
          " MO1-T275: Beim Einsehen der Prozessdaten in der Prozesslandkarte ist nun kein Code mehr zu sehen",
          " MO1-T188: Die Elemente in der Ablaufbeschreibung können individuell angeordnet werden",
          " MO1-T274: Die Funktion „Prozessfreigabe“ ist nun deaktiviert",
        ],
      },
      {
        versionInfo: "v4.2.4",
        date: "29.01.2025",
        fixes: [
          "	MO1-T193: Das Textfeld zum Erstellen einer benutzerdefinierten Seite vergrößerte sich bei Eingabe, sodass es unter dem Hinweistextfeld angeordnet wird. Nun ist es rechts angeordnet und verfügt über eine Scroll-Funktion.",
          "	MO1-T231: Fehler bei Ordnerberechtigungen: bis dato hatte man mit der Rolle „Nutzer“ Zugriff auf Ordner, für die man keine Anzeigeberechtigung haben sollte. Dies wurde behoben.",
          "	MO1-T241: Als Nutzer können nun Sub-Prozesse auch im Lese-Modus angesehen werden.",
          "	MO1-T244: Es ist nun möglich, Sonderzeichen im Prozessmodell -Name zu verwenden.",
          "	MO1-T261: In der Prozessliste werden nun bei Suchergebnissen nur noch jene Ordner angezeigt, die einen Treffer enthalten.",
          "	MO1-T262: Beim Hinzufügen eines Systems an ein Prozessmodell, ist dieses nun auch nach dem Speichern, anschließendem Verlassen und erneuten Öffnen des Bearbeitungsmodus noch vorhanden.",
          "	MO1-T264: Bei der Freigabe ist nun standardmäßig kein Prozessverantwortlicher vorausgewählt.",
          "	MO1-T235: Als Nutzer kann nun via Zurück-Pfeil automatisch die Bearbeitung des Prozessmodells verlassen werden (inkl. Hinweis darauf).",
          "	MO1-T247: Nutzer sollten im Prozesssteckbrief nicht die Möglichkeit haben, neue Prozessobjekte hinzuzufügen",
          "	MO1-T130: Der Ersteller einer Freigabeanfrage erhält nun eine Rückmeldung über das Ergebnis der Freigabe. ",
          "	MO1-T179: Beim Hinzufügen einer neuen Frage werden Pflichtfelder nun als solche gekennzeichnet. ",
          "	MO1-T180: Nutzer haben nun die Berechtigung, erstellte Fragen löschen zu können.",
          "	MO1-T245: Während der Bearbeitung kann kein Bericht heruntergeladen werden, jedoch bekommen Nutzer nun eine Rückmeldung via PopUp dazu. ",
          "	MO1-T131: Beim Löschen eines Prozesssteckbriefs wird nun noch einmal explizit nachgefragt, ob der Prozesssteckbrief endgültig gelöscht werden soll.",
          "	MO1-T160: Nutzern ist es nun möglich, Prozessmodelle direkt im Prozesssteckbrief zu verknüpfen. ",
          "	MO1-T238: Objektlisten werden nun standardmäßig alphabetisch angezeigt.",
          "	MO1-T250: Nutzer haben nun die Möglichkeit, Prozesssteckbriefe zu durchsuchen.",
          " MO1-T242: Beim Import von Prozessmodellen, wird der Annex „.bpmn“ nun automatisch entfernt. ",
          "	MO1-T240: Nutzer können nun Subprozesse erstellen und diese frei benennen (auch, wenn der Subprozess noch nicht existiert).  ",
        ],
      },
      {
        versionInfo: "v4.2.3",
        date: "13.08.2024",
        fixes: [
          "Ein Nutzer bekam bei Anmeldung die Fehlermeldung 'Dieser Benutzer existiert nicht'. Dies wurde nun behoben und die Fehlermeldung wurde angepasst.",
          /*Die Hintergrundfarbe von Prozessobjekten ist standardmäßig schwarz, sodass der Name des Objektes nicht lesbar war. Nun wird die Schriftfarbe automatisch für einen möglichst hohen Kontrast angepasst und ist somit wieder lesbar.”,
                    “In der Prozesslandkarte wurden Abteilungen angezeigt, die nicht im Filter inkludiert waren. Als Nutzer möchte ich in der Prozesslandkarte nur die Abteilungen sehen, die im Filter ausgewählt sind”,
                    “In der Prozesslandkarte waren die Fallzahlen pro Monat falsch sortiert. Diese werden jetzt in der richtigen Reihenfolge angezeigt.”,
                    “Der Freigabeprozess wurde bisher fehlerhaft zugeordnet, dieser wird nun richtig zugeordnet.”,
                    “Prozesse konnten nicht in andere Ordner verschoben werden, dies funktioniert jetzt.”,
                    "Im Reiter "Zu prüfende Prozesse" sind zu sehen, die nicht mir zur Freigabe zugeordnet wurden, sondern einer anderen Person. Nun sind nur noch die Prozesse sichtbar, die mir zur Freigabe zugewiesen wurden.",
                    “Im Freigabeprozess waren Beschreibungen und Kommentare nicht sichtbar, diese können nun eingesehen werden.”*/
        ],
      },
      {
        versionInfo: "v4.2.2",
        date: "29.07.2024",
        fixes: [
          "Änderungen im Prozesssteckbrief wurden nicht gespeichert, dies ist nun möglich.",
          "Das Teilen eines Prozesses führte zu einem 500-Fehler, was nun nicht mehr der Fall ist.",
          "Prozessobjekte konnten bis dato im Nachhinein nicht bearbeitet und gespeichert werden, dies funktioniert nun.",
        ],
      },
      {
        versionInfo: "v4.2.1",
        date: "04.07.2024",
        fixes: [
          "Der Filter “Prozessart” kann nun ausgewählt werden.",
          "Im Prozesssteckbrief kann unter “Schnittstellenauswahl” nun nach unten gescrollt werden.",
          "Bestimmte Nutzer sehen nun alle Reiter der Navigation (links).",
          "Das Freigeben von Ordnern funktioniert nun.",
          "Wenn für einen Prozess mehrere Umfragen hinterlegt sind, sind nun alle Umfragen sichtbar, ohne dass diese abgeschnitten werden.",
          "In der Prozesslandkarte sind unter den Prozessdaten nun nur noch die relevanten Schnittstellen zu Abteilungen sichtbar.",
          "Beim Teilen eines Prozessmodells erscheint nun nicht mehr der Fehler 404.",
          "Neue Mandanten haben nun automatisch einen Standardordner in der Prozessmodellierung.",
          "Nach dem Hinzufügen eines neuen Prozessobjekt wird die Seite nun automatisch neu geladen, sodass das Prozessobjekt direkt sichtbar ist.",
          "Neu erstellte Fragen erscheinen nun unter “Meine Fragen”.",
          "Es können nun neue Fragen für benutzerdefinierte Umfragen erstellt werden.",
          "Bei den Antwortmöglichkeiten von Fragen findet nun keine Textüberlagerung mehr statt.",
          "Mandanten können nun wieder problemlos gewechselt werden.",
        ],
      },
    ],
  }),
  components: { LearnPage },
};
</script>
<style scoped lang="scss">
:deep .v-list-item--active {
  color: var(--v-primary-base) !important;
}
.card {
  -webkit-box-shadow: 5px 5px 20px var(--gray-color_4);
  -moz-box-shadow: 5px 5px 20px var(--gray-color_4);
  box-shadow: 5px 5px 20px var(--gray-color_4) !important;
}
.version-info {
  padding: 0 10px;
  height: 24px;
  font-size: 12px;
  font-weight: 600;
  position: absolute;
  left: 0;
  top: 0;
}
</style>